import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicGuarantor({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M7.68 2.1a1 1 0 01.64 0l5.36 1.8c.2.06.33.24.34.44.34 7.44-3.74 9.52-5.8 10.55a.5.5 0 01-.44 0c-2.06-1.03-6.14-3.11-5.8-10.55.01-.2.15-.38.34-.45zm2.8 3.98a.3.3 0 00-.42 0l-2.81 2.7-1.31-1.26a.3.3 0 00-.43 0l-.42.4a.3.3 0 000 .41l1.95 1.87c.12.11.3.11.42 0l3.45-3.3a.3.3 0 000-.41z" />
    </svg>
  );
}

SvgBasicGuarantor.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicGuarantor.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicGuarantor svgRef={ref} {...props} />);
export default ForwardRef;
